import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import localStorage from 'redux-persist/lib/storage';

import { cookieReducers } from './cookie-reducers';
import { localStorageReducers } from './local-reducers';
import { memoryStorageReducers } from './memory-reducers';
import * as ActionTypes from './constants';
import {
  isCookieSupported,
  isLocalStorageSupported,
} from './shared/utils/utils';

const getPersistedStorageReducer = (storage, key, reducer) => {
  const persistConfig = {
    key,
    storage,
    timeout: null, // Bug in redux-persist: https://github.com/rt2zz/redux-persist/issues/786
  };

  if (reducer.whitelist) {
    persistConfig.whitelist = reducer.whitelist;
  }

  if (reducer.blacklist) {
    persistConfig.blacklist = reducer.blacklist;
  }

  return persistReducer(persistConfig, reducer);
};

const createStoredReducer = (storage, reducers) => {
  const result = {};

  for (const [name, reducer] of Object.entries(reducers)) {
    result[name] = getPersistedStorageReducer(storage, name, reducer);
  }
  return result;
};

export const getAppReducer = cookieStorage => {
  const appReducer = (state = {}, action) => {
    const { type, payload } = action;

    if (type === ActionTypes.SET_PREVIOUS_LOCATION) {
      return { ...state, previousLocation: payload };
    }

    if (type === ActionTypes.SET_ERROR_MESSAGE) {
      return { ...state, errorMessage: payload.error };
    }

    return state;
  };

  let persistedCookieStorageReducer = {};
  let persistedLocalStorageReducer = {};

  if (isCookieSupported(cookieStorage)) {
    persistedCookieStorageReducer = createStoredReducer(
      cookieStorage,
      cookieReducers,
    );
  } else {
    persistedCookieStorageReducer = cookieReducers;
  }

  if (isLocalStorageSupported()) {
    persistedLocalStorageReducer = createStoredReducer(
      localStorage,
      localStorageReducers,
    );
  } else {
    persistedLocalStorageReducer = localStorageReducers;
  }

  const reducers = {
    ...persistedCookieStorageReducer,
    ...persistedLocalStorageReducer,
    ...memoryStorageReducers,
    app: appReducer,
  };

  return combineReducers(reducers);
};
